import { render } from "./ChevronRight.vue?vue&type=template&id=60485342&scoped=true"
import script from "./ChevronRight.vue?vue&type=script&lang=js"
export * from "./ChevronRight.vue?vue&type=script&lang=js"

import "./ChevronRight.vue?vue&type=style&index=0&id=60485342&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60485342"]])

export default __exports__